import type { User } from '@/types/user'
import { ENTERPRISE_API_TAG, ENTERPRISE_MCP_TAG } from '@/components/dashboard/layout/workspaces/workspaces-context'

export const ENTERPRISE_API_WRITE_ROLE = 'enterprise-api-write' as const
export const ENTERPRISE_API_ROLES = ['enterprise-api', ENTERPRISE_API_WRITE_ROLE] as const
export const GLOBAL_ACCESS_ROLE = 'global-access'

export function hasEnterpriseApiRole(user?: User | null): boolean {
	return ENTERPRISE_API_ROLES.some((role) => user?.roles?.includes(role))
}

export function hasAllEnterpriseApiRoles(user?: User | null): boolean {
	return ENTERPRISE_API_ROLES.every((role) => user?.roles?.includes(role) === true)
}

export function hasEnterpriseMcpAccess(user?: User | null): boolean {
	const hasOperatorScope = Boolean(user?.portal_operator) || user?.roles?.includes(GLOBAL_ACCESS_ROLE) === true
	return hasEnterpriseApiRole(user) && hasOperatorScope && Boolean(user?.email)
}

export function canAccessEnterpriseApiSettings(user?: User | null): boolean {
	return user?.tags?.includes(ENTERPRISE_API_TAG) === true && hasEnterpriseMcpAccess(user)
}

export function canAccessEnterpriseMcpSettings(user?: User | null): boolean {
	return user?.tags?.includes(ENTERPRISE_MCP_TAG) === true && hasEnterpriseMcpAccess(user)
}
